import { render, staticRenderFns } from "./couponTemplate.vue?vue&type=template&id=59fbb6c0&scoped=true&"
import script from "./couponTemplate.vue?vue&type=script&lang=js&"
export * from "./couponTemplate.vue?vue&type=script&lang=js&"
import style0 from "./couponTemplate.vue?vue&type=style&index=0&id=59fbb6c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59fbb6c0",
  null
  
)

export default component.exports